import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { OrganisationService } from '@services/organisations/organisation.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-cleanup-customer',
    templateUrl: './cleanup-customer.component.html',
    styleUrls: ['./cleanup-customer.component.scss'],
    providers: [OrganisationService],
    standalone: false
})
export class CleanupCustomerComponent implements OnInit {

  public title = 'Organisations';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'title' }
  ];

  constructor(private http: HttpClient, public organisationService: OrganisationService, private router: Router) {
  }

  ngOnInit() {
  }

  onDetail(event: any) {
    this.router.navigate(['cleanup-customer', event.row.OrganisationID]);
  }
}
